import React, { useState } from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCollapse,
  MDBCollapseHeader,
  MDBContainer,
  MDBIcon,
} from "mdbreact";
import { useSelector } from "react-redux";
import {
  capitalize,
  handlePagination,
} from "../../../../../../services/utilities";
import CollapseTable from "./table";
import Disposables from "./disposables";

const TABS = [
  {
    key: "references",
    label: "Reference Value",
    icon: "sliders-h",
    color: "#1976d2",
  },
  {
    key: "disposables",
    label: "Disposable",
    icon: "syringe",
    color: "#00897b",
  },
];

export default function ServiceCollapse() {
  const { cluster, activePage, maxPage } = useSelector(
      ({ preferences }) => preferences,
    ),
    [activeId, setActiveId] = useState(0),
    [tab, setTab] = useState("references");

  const handleOpen = (id) => setActiveId((prev) => (prev === id ? 0 : id));

  return (
    <MDBContainer style={{ minHeight: "300px" }} fluid className="md-accordion">
      {handlePagination(cluster, activePage, maxPage)?.map(
        ({ id, name, abbreviation, references, preference }, index) => {
          const isOpen = id === activeId;
          return (
            <MDBCard key={`services-${index}`}>
              <MDBCollapseHeader onClick={() => handleOpen(id)}>
                {(activePage - 1) * maxPage + index + 1}. {capitalize(name)}
                {abbreviation && ` | ${abbreviation.toUpperCase()}`}
                {preference && (
                  <span className="text-primary">
                    &nbsp; Preference : {capitalize(preference)}
                  </span>
                )}
                <i
                  style={{
                    rotate: `${isOpen ? 0 : 90}deg`,
                    transition: "transform 0.3s",
                  }}
                  className="fa fa-angle-down"
                />
              </MDBCollapseHeader>
              <MDBCollapse id={`collapse-${id}`} isOpen={isOpen}>
                {/* content is only mounted when open, so disposables load per service */}
                {isOpen && (
                  <MDBCardBody className="pt-2">
                    <ul className="nav nav-tabs mb-3">
                      {TABS.map(({ key, label, icon, color }) => {
                        const isActive = tab === key;
                        return (
                          <li key={key} className="nav-item">
                            <button
                              type="button"
                              className={`nav-link btn m-0 mr-1 py-2 px-3 ${
                                isActive ? "active font-weight-bold" : ""
                              }`}
                              style={{
                                textTransform: "none",
                                boxShadow: "none",
                                borderRadius: "6px 6px 0 0",
                                background: isActive ? color : "transparent",
                                color: isActive ? "#fff" : color,
                                borderColor: isActive ? color : "transparent",
                              }}
                              onClick={() => setTab(key)}
                            >
                              <MDBIcon icon={icon} className="mr-1" />
                              {label}
                            </button>
                          </li>
                        );
                      })}
                    </ul>

                    {tab === "references" &&
                      (preference ? (
                        <CollapseTable
                          id={id}
                          references={references || []}
                          preference={preference}
                        />
                      ) : (
                        <p className="text-center text-muted small my-3">
                          This service has no reference value preference.
                        </p>
                      ))}
                    {tab === "disposables" && <Disposables serviceId={id} />}
                  </MDBCardBody>
                )}
              </MDBCollapse>
            </MDBCard>
          );
        },
      )}
    </MDBContainer>
  );
}
